import React from "react";

import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { Control, Controller, useFieldArray } from "react-hook-form";

import { ExistingDocument } from "./ExistingDocument";
//import { NewDocument } from "./NewDocument";
import { RecognitionApplicationViewModel } from "../../../../domain/viewModels/RecognitionApplicationViewModel";

type ReviewDocumentsProps = {
  control: Control<RecognitionApplicationViewModel>;
  fieldName: keyof Pick<
    RecognitionApplicationViewModel,
    "reviewAttachments" | "panelAttachments"
  >;
  download: (id: string) => Promise<Blob>;
  readOnly?: boolean;
};

export const ReviewDocuments: React.FC<ReviewDocumentsProps> = ({
  control,
  fieldName,
  download,
  readOnly,
}) => {
  const { fields } = useFieldArray({
    control,
    name: fieldName,
    keyName: "_id",
  });

  const [firstChar, ...rest] = String(fieldName);
  const newDocumentFieldName = `new${firstChar.toUpperCase()}${rest.join("")}`;

  return (
    <>
      {fields.map((field, index) => {
        return (
          <React.Fragment key={field._id}>
            <Controller
              control={control}
              name={`${fieldName}[${index}].isToDelete`}
              defaultValue={field.toDelete || false}
              render={({ value, onChange }) => (
                <ExistingDocument
                  value={value}
                  onChange={onChange}
                  itemValues={field}
                  download={download}
                  readOnly={readOnly}
                />
              )}
            />
          </React.Fragment>
        );
      })}

      <Controller
        control={control}
        name={newDocumentFieldName}
        render={({ ...props }) => (
          <div style={{ marginTop: 20 }}>
            {!!props.value?.length && (
              <div>
                <strong>Files to upload:</strong>
              </div>
            )}
            <FileInput
              {...props}
              multiple={true}
              buttonPosition="belowFiles"
              disabled={readOnly}
            ></FileInput>
          </div>
        )}
      />
    </>
  );
};

//<FileInput multiple={true} buttonPosition="belowFiles">
//{/* {(props) => <NewDocument {...props} />} */}
//</FileInput>
